const initNewsFiltering = () => {
  const newsFilteringContainer = document.querySelector('.news-filtering');

  if (newsFilteringContainer) {
    const url = new URL(window.location.href);
    const dropdownButton = document.querySelector('.choose-button');
    const dropdown = document.querySelector('.category-search');
    const dropdownItems = document.querySelectorAll('.filter-item button');
    const newsResultsContainer = document.querySelector('#newsroom-results');
    const searchButton = document.querySelector('#search-news');
    const newsModules = document.querySelectorAll('.module.news');
    const filteringText = document.querySelector('.filtering-text');
    const removeFilter = document.querySelectorAll('.remove-filter');
    const socialMedia = document.querySelector('.module.social-media');

    dropdownButton.addEventListener('click', () => {
      dropdown.classList.toggle('active');
    });

    dropdownItems.forEach((item) => {
      item.addEventListener('click', () => {
        const selectedCategory = item.dataset.id;
        const selectedCategoryText = item.textContent;
        dropdownButton.textContent = selectedCategoryText;
        dropdown.classList.remove('active');
      });
    });

    searchButton.addEventListener('click', () => {
      const selectedCategory = dropdownButton.textContent;
      const inputValue = document.querySelector('.search-input').value;
      filteringText.innerHTML = '';

      if (!isWhitespaceString(selectedCategory)) {
        if (selectedCategory !== '') {
          if (!url.searchParams.has('category')) {
            url.searchParams.append('category', selectedCategory);
          } else {
            url.searchParams.set('category', selectedCategory);
          }
        }
      }

      if (inputValue) {
        if (!url.searchParams.has('search')) {
          url.searchParams.append('search', inputValue);
        } else {
          url.searchParams.set('search', inputValue);
        }
      }

      history.pushState({}, '', url.href);

      getNewsroomResults(selectedCategory, inputValue);
    });

    // Search Functionality
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    const restBase = protocol + '//' + hostname + '/wp-json/newsroom-rest/v1';

    const getNewsroomResults = (category, searchInput) => {
      if (isWhitespaceString(category)) {
        category = '';
      }

      let data = {
        action: 'newsroom_rest',
        category: category,
        search_input: searchInput,
      };

      if (category) {
        filteringText.innerHTML += `<button class="remove-filter" data-type="category" data-value="${category}">
          ${category} 
          <svg class="icon icon-filter-close" aria-hidden="true">
            <use xlink:href="#icon-filter-close"></use>
          </svg>
        </button>`;
      }

      if (searchInput) {
        filteringText.innerHTML += `<button class="remove-filter"" data-type="text" data-value="${searchInput}">
          ${searchInput} 
          <svg class="icon icon-filter-close" aria-hidden="true">
            <use xlink:href="#icon-filter-close"></use>
          </svg>
        </button>`;
      }

      socialMedia.remove();
      const removeFilter = document.querySelectorAll('.remove-filter');

      removeFilter.forEach((item) => {
        item.addEventListener('click', () => {
          let category = '';
          let text = '';

          item.remove();

          const categoryFilter = document.querySelector(
            '.remove-filter[data-type="category"]',
          );

          const textFilter = document.querySelector(
            '.remove-filter[data-type="text"]',
          );

          if (!categoryFilter) {
            dropdownButton.textContent = '';
            if (url.searchParams.has('category')) {
              url.searchParams.delete('category');
            }
          } else {
            category = categoryFilter.getAttribute('data-value');
          }

          if (!textFilter) {
            document.querySelector('.search-input').value = '';

            if (url.searchParams.has('search')) {
              url.searchParams.delete('search');
            }
          } else {
            text = textFilter.getAttribute('data-value');
          }

          history.pushState({}, '', url.href);
          filteringText.innerHTML = '';

          getNewsroomResults(category, text);
        });
      });

      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': newsroom_rest.apiNonce,
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          data: data,
        }),
      };

      fetch(restBase + '/search', options)
        .then((response) => {
          if (!response.ok) {
            const statusError = 'Error getting Search from API';
            console.log(statusError, response);
          }
          return response.json();
        })
        .then((response) => {
          if (response.posts !== '') {
            newsModules.forEach((module) => {
              module.style.display = 'none';
            });

            newsResultsContainer.classList.add('active-results');
            newsResultsContainer.innerHTML = response.posts;
          } else {
            newsResultsContainer.classList.remove('active-results');
            newsResultsContainer.innerHTML = '';
          }
        })
        .catch((response) => {
          console.log(response);
        });
    };

    if (url.searchParams.has('search') || url.searchParams.has('category')) {
      const categorySearch = url.searchParams.get('category');
      const searchInput = url.searchParams.get('search');

      getNewsroomResults(categorySearch, searchInput);
    }
  }

  function isWhitespaceString(str) {
    if (str) {
      return !str.replace(/\s/g, '').length;
    }
  }
};

export default initNewsFiltering;
